import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { setCreatedData } from '../../../../ReduxToolkit/Reducers/ProjectSlice';
import { Form, Formik, ErrorMessage, Field } from 'formik';
import { Col, FormGroup, Label, Row } from 'reactstrap'
import { CategoryInitialValue } from '../../../../Types/Application/ProjectList/ProjectList';
import ButtonSection from '../ProjectCreate/ButtonSection';
import Swal from 'sweetalert2';
import api from '../../../../utils/api';
import { categoryInitialValue, categoryValidation } from '../../../../Data/Application/ProjectList/ProjectList';

const CategoryForm = () => {
    const navigate = useNavigate();
    const { createdFormData } = useAppSelector((state) => state.project);
    const dispatch = useAppDispatch();
  
    const projectSubmit = async (values: CategoryInitialValue) => {
      const submittedData = {
        foodCategoryId: 0,
        categoryName: values.categoryName,
      };
      if (!submittedData.categoryName || submittedData.categoryName.trim() === "") {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please fill all the required fields.',
        });
        return; // Stop submission if validation fails
      }
      dispatch(setCreatedData([...createdFormData, submittedData]));
      try {
        const response = await api.post('/api/FoodCategory/AddFoodCategory', submittedData, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (response.status === 200 || response.status === 201) {
          dispatch(setCreatedData([...createdFormData, response.data]));
    
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Category created successfully.',
          }).then(() => {
            navigate(`${process.env.PUBLIC_URL}/food/categoryList`);
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Unexpected Response',
            text: 'Please try again later.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'Something went wrong while creating the category.',
        });
      }
    };
    return (
      <Formik initialValues={categoryInitialValue} validationSchema={categoryValidation} onSubmit={projectSubmit}>
        {() => (
          <Form className="theme-form">
            <Row>
                <Col sm="4">
                <FormGroup>
                    <Label check>Category Name</Label>
                    <Field name="categoryName" type="text" className="form-control" placeholder="Enter category name here..." />
                    <ErrorMessage name="categoryName" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4" className='mt-4'>
                    <ButtonSection cancel_url={`/food/categoryList`} />
                </Col>
            </Row>
            
          </Form>
        )}
      </Formik>
    )
}

export default CategoryForm